var _rect, _path, _path2, _rect2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleIllustrationRules = function SvgSimpleIllustrationRules(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31.97,
    height: 10.775,
    x: 6.078,
    y: 11.693,
    fill: "#FFFAF0",
    stroke: "#002140",
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002140",
    d: "M18.139 14.333h10.99v1.494h-10.99zM18.139 18.258h16.485v1.494H18.139z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#03D47C",
    fillRule: "evenodd",
    d: "M15.143 13.781a.896.896 0 0 1 .189 1.254l-3.901 5.282-2.803-2.56a.896.896 0 0 1 1.209-1.324l1.334 1.218 2.719-3.681a.896.896 0 0 1 1.253-.189Z",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31.97,
    height: 10.775,
    x: 10.657,
    y: 25.431,
    fill: "#FFFAF0",
    stroke: "#002140",
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#002140",
    d: "M22.718 28.071h10.99v1.494h-10.99zM22.718 31.996h16.485v1.494H22.718z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F25730",
    d: "M18.368 33.584a.777.777 0 0 0 1.098-1.099l-1.78-1.78 1.78-1.78a.777.777 0 0 0-1.098-1.097l-1.78 1.78-1.78-1.781a.777.777 0 0 0-1.098 1.098l1.78 1.78-1.78 1.781a.777.777 0 0 0 1.098 1.098l1.78-1.78 1.78 1.78Z"
  })));
};
export default SvgSimpleIllustrationRules;